/* eslint-disable @typescript-eslint/ban-types */
import React, { FC } from 'react';
import { Tooltip, IconButton, FormLabel } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { CustomInput, SelectDropDown } from '../../../globalUtils/globalExports';
import { CustomDropdownPropTypes } from '../../../globalUtils/SelectDropDown/SelectDropDown';
import { CustomInputFieldPropTypes } from '../../../globalUtils/CustomInput/CustomInput';
import '../../components/configureNotification/AcCreateRuleAlertLogic.css';

interface IAcAlarmType {
  severity: string;
  id: string;
  name: string;
}

export interface AcAlertLogicProps {
  alarmList?: IAcAlarmType[] | null;
  selectDropdownProps: CustomDropdownPropTypes | null;
  formLabel: string;
  isRequired: boolean;
  inputProps: CustomInputFieldPropTypes | null;
  createRuleFormData?: AcCreateRuleFormData | null;
  handleFormDataChange?: Function;
}

const AcCreateRuleAlertLogic: FC<AcAlertLogicProps> = (props) => {
  const { createRuleFormData } = props;
  console.log(createRuleFormData, 'createRuleFormData');

  return (
    <>
      <div className='create__rule__alert__logic__wrapper'>
        <div className='create__rule__alert__logic__header__info__wrapper'>
          <div className='create_rule_alert_section_headings'>
            Alert Logic
          </div>
          <Tooltip
            title={
              <>
                Alert Logic can be configured for Alarm-based Notifications:
                <br />
                Alarm: Notify on new alarm (or) if an alarm persists for the duration set in &apos;Alarm continues for&apos; field.
              </>
            }
            componentsProps={{ tooltip: { sx: { boxShadow: 'none' } } }}
          >
            <IconButton sx={{ padding: 0, marginLeft: 1 }}>
              <InfoOutlinedIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        </div>

        <div className='alert__logic__row__content'>
          <div className='d-flex' style={{ gap: '15px', width: '100%' }}>
            <div className='custom__form__wrap-content-column alert__logic__alarm__dropdown'>
              <div className='flex-tooltip'>
                {props?.formLabel && (
                  <FormLabel className={'rms-form-label'} required={props?.isRequired}>
                    {props?.formLabel}
                  </FormLabel>
                )}
              </div>
              {props?.selectDropdownProps !== null && (
                <SelectDropDown
                  selectValue={props?.selectDropdownProps?.selectValue}
                  selectOptions={props?.selectDropdownProps?.selectOptions}
                  handleSelectOptionChange={props?.selectDropdownProps?.handleSelectOptionChange}
                  selectDropDownId={props?.selectDropdownProps?.selectDropDownId}
                  selectDropDownName={props?.selectDropdownProps?.selectDropDownName}
                  isMultiSelect={props?.selectDropdownProps?.isMultiSelect}
                  isDisabled={props?.selectDropdownProps?.isDisabled}
                  handleClose={props?.selectDropdownProps?.handleClose}
                  renderToBody={props?.selectDropdownProps?.renderToBody}
                  secondaryLabel={props?.selectDropdownProps?.secondaryLabel}
                  secondaryLabelView={props?.selectDropdownProps?.secondaryLabelView}
                />
              )}
            </div>

            <div className='alert__logic__alarm__continues__for'>
              <div className='alert__logic__row__label'>
                Alarm Continues for
              </div>
              <div className='alert__logic__minute__input'>
                <CustomInput
                  inputPlaceHolder={''}
                  handleInputChange={props?.inputProps?.handleInputChange}
                  inputValue={props?.inputProps?.inputValue || ''}
                  inputFieldId={props?.inputProps?.inputFieldId || ''}
                  isRequired={props?.inputProps?.isRequired || false}
                  handleKeyPress={(e) => {
                    if (!/^\d$/.test(e.key) && e.key !== 'Backspace') {
                      e.preventDefault();
                    }
                  }}
                  isDisabled={props?.inputProps?.isDisabled}
                  errorMessage={props?.inputProps?.errorMessage}
                  autoFocus={props?.inputProps?.autoFocus}
                /> minutes
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AcCreateRuleAlertLogic;
